import React from "react";

import { useQuery } from "@apollo/client/react/hooks";

import { OrderByDirection } from "@/gql/graphql";
import { formatISODate } from "@/utils/datetime";

import { ClientList } from "./ClientList";
import { moduleAnsweringClientsQuery } from "../graphql/dashboardPageQueries";

export const ModuleAnsweringTab: React.FC = () => {
  const { data, loading, refetch } = useQuery(moduleAnsweringClientsQuery, {
    variables: {
      currentDate: formatISODate(new Date()),
      orderByName: OrderByDirection.Asc,
      statuses: ["active", "struggling", "inactive"],
    },
  });

  return (
    <ClientList
      isLoading={loading}
      tab="modules"
      clients={data?.moduleAnsweringClients.nodes ?? []}
      onSort={(sortBy) => refetch({ orderByName: sortBy })}
      onSearch={(searchKey) => refetch({ searchKey })}
      onFilterStatus={(statuses: string[]) => refetch({ statuses })}
    />
  );
};
